import axios from 'axios';
import { RunConfigService } from '@nuskin/ns-util';
import { getPartialConfig } from '@nuskin/configuration-sdk';

const ZZIP_URLS = {
    dev: 'https://apis.dev.nuskin.com/zzip/v2/:country/:postalCode',
    test: 'https://apis.test.nuskin.com/zzip/v2/:country/:postalCode',
    prod: 'https://apis.nuskin.com/zzip/v2/:country/:postalCode',
};

const mixin = {
    data() {
        return {
            postalCodeResetRefs: [],
            postCodeLookedUp: false,
            // This is the default if you use this mixin make sure to override this
            postCodeLength: 5,
        };
    },
    methods: {
        canLookupPostalCode() {
            return (
                this.value &&
        this.address.postalCode &&
        this.address.postalCode.length === this.postCodeLength
            );
        },
        async postCodeChanged() {
            // Do the postal code lookup when we have a valid postal code
            if (this.canLookupPostalCode()) {
                await this.postalCodeLookup();
            } else {
                this.postCodeLookedUp = false;
            }

            this.postalCodeReset();
            this.addressUpdated();
        },
        async postalCodeLookup() {
            // Uses zzip commonly
            /** @type {string} */ let url;
            url = ZZIP_URLS[RunConfigService.getEnvironmentCode()]
                .replace(':country', this.address.country)
                .replace(':postalCode', this.address.postalCode);

            try {
                const response = await axios.get(url);
                const records = response && response.data && response.data.zzipRecords;
                if (records && records.length > 0) {
                    const firstRecord = records[0];
                    this.$set(
                        this.address,
                        'postalCode',
                        firstRecord.postalCode,
                    );
                    this.$set(this.address, 'region', firstRecord.region);
                    this.$set(this.address, 'city', firstRecord.city);
                    // For Mexico don't preselect the district
                    if (firstRecord.district && !(this.address.country === 'MX')) {
                        this.$set(this.address, 'district', firstRecord.district);
                    }
                    this.districts = records.map((rec) => rec.district).sort();
                    this.postCodeLookedUp = true;
                    this.$emit('postal-code-looked-up', true);
                } else {
                    this.$emit('postal-code-looked-up', false);
                    this.postCodeLookedUp = false;
                }
            } catch (err) {
                this.postCodeLookedUp = false;
                // Error Handling for MY and JP
                if (['MY', 'JP'].includes(this.address.country) && (err && err.response && err.response.status == 404)) {
                    this.$emit('postal-code-looked-up', false);
                }
            }
            // If we fail to get the postal code set the field to an error state
            this.postCodeErrors = this.postCodeLookedUp
                ? []
                : [this.t.invalidPostalCode];
        },
        postalCodeReset() {
            if (this.postCodeLookedUp) {
                // Call resetValidation to fix the validation issue that occurs
                // after postal code lookup.
                this.postalCodeResetRefs.forEach((ref) => {
                    ref.resetValidation();
                });
            }
        },
    },
};

export default mixin;
